import { BookOpen, GraduationCap, Globe2, Building2 } from "lucide-react";

const STATS = [
  { value: "400+", label: "Online Courses", icon: BookOpen },
  { value: "36,000+", label: "Learners Trained", icon: GraduationCap },
  { value: "37+", label: "Countries Served", icon: Globe2 },
  { value: "350+", label: "Corporate Clients", icon: Building2 },
];

export default function ImpactMetrics({
  surface = "dark",
  eyebrow,
  headline,
  className = "",
}) {
  // Controls ONLY the heading colors
  const headingDark = surface === "dark";

  return (
    <section data-testid="impact-metrics" className={className}>
      {(eyebrow || headline) && (
        <div className="mb-8">
          {eyebrow && (
            <p
              className={`font-mono-ui text-[11px] uppercase tracking-[0.24em] ${
                headingDark ? "text-[var(--cyan)]" : "text-royal"
              }`}
            >
              {eyebrow}
            </p>
          )}

          {headline && (
            <h2
              className={`font-display text-2xl md:text-3xl font-bold mt-3 leading-[1.08] text-balance max-w-2xl ${
                headingDark ? "text-white" : "text-ink"
              }`}
            >
              {headline}
            </h2>
          )}
        </div>
      )}

      {/* Card ALWAYS stays blue */}
      <div className="rounded-2xl overflow-hidden bg-royal-deep text-white">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-white/10">
          {STATS.map((s) => (
            <div
              key={s.label}
              data-testid={`impact-stat-${s.label
                .toLowerCase()
                .replace(/\s+/g, "-")}`}
              className="p-6 lg:p-8 flex flex-col items-center text-center"
            >
              <s.icon
                size={18}
                className="text-[var(--cyan)]"
                aria-hidden
              />

              <p
                className="font-display text-3xl lg:text-[42px] font-bold leading-none mt-3"
                style={{ color: "var(--cyan)" }}
              >
                {s.value}
              </p>

             <p className="mt-2 text-sm leading-relaxed text-white/70 text-center">
  {s.label}
</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}